const counselorTypes = {
    livePrep: 'counselorLiveprep',
    counseling: 'counselorCounseling',
  }
  
  export default counselorTypes